import { useState } from 'react'
import { useDispatch } from 'react-redux'
import CircularProgress from '@mui/material/CircularProgress'
import { VyneRadio } from '@vynedental/design-system'
import { RadioChangeEvent } from 'antd'
import classNames from 'classnames'

import { savePractice } from '../../modules/practices/actions'

import './ManageProducts.sass'

export type ManageSalesforceTypeProps = {
    practice: Models.Practice
    onClose: () => void
}

export type ManageSalesforceTypeDispatch = {}

export type ManageSalesforceTypeState = {
    salesforceType: 'vyne' | 'simplifeye'
    isVyneSalesforceDirty: boolean
    isDirty: boolean
}

type Props = ManageSalesforceTypeProps & ManageSalesforceTypeDispatch

const ManageSalesforceType = (props: Props) => {
    const [salesforceType, setSalesforceType] = useState<'vyne' | 'simplifeye'>(
        props.practice.isVyneCreated ? 'vyne' : props.practice.salesforceType || 'simplifeye',
    )

    const [isVyneSalesforceDirty, setIsVyneSalesforceDirty] = useState<boolean>(false)
    const [isSavingSalesforce, setIsSavingSalesforce] = useState<boolean>(false)

    const dispatch = useDispatch()

    const onSelectSalesforceType = (e: RadioChangeEvent) => {
        setSalesforceType(e.target.value as 'vyne' | 'simplifeye')
        setIsVyneSalesforceDirty(true)
    }

    const onSaveSalesforce = async () => {
        if (isVyneSalesforceDirty) {
            setIsSavingSalesforce(true)
            await dispatch(savePractice(props.practice, { salesforce_type: salesforceType }))
            setIsSavingSalesforce(false)
        }
        props.onClose()
        return
    }

    return (
        <div className="manage-products">
            <div className="form">
                <div className="title">Salesforce Type</div>
                <div className={`manage-products__salesforce-type`}>
                    <div className={`manage-products__radio-wrapper`}>
                        <VyneRadio
                            dataTestId="vyne-salesforce-type"
                            checked={salesforceType === 'vyne'}
                            onChange={onSelectSalesforceType}
                            name="radio-vyne-salesforce"
                            value="vyne"
                            disabled={props.practice.isVyneCreated || isSavingSalesforce}
                            isStandalone
                            style={{ marginBottom: 0 }}
                        >
                            Vyne Salesforce
                        </VyneRadio>
                    </div>
                    <div className={`manage-products__radio-wrapper`}>
                        <VyneRadio
                            dataTestId="simplifeye-salesforce-type"
                            checked={salesforceType === 'simplifeye'}
                            onChange={onSelectSalesforceType}
                            name="radio-simplifeye-salesforce"
                            value="simplifeye"
                            disabled={props.practice.isVyneCreated || isSavingSalesforce}
                            isStandalone
                            style={{ marginBottom: 0 }}
                        >
                            Simplifeye Salesforce
                        </VyneRadio>
                    </div>
                </div>
            </div>
            <button
                className={classNames('bottom-save-button', {
                    'can-save': isVyneSalesforceDirty && !isSavingSalesforce,
                })}
                disabled={!isVyneSalesforceDirty || isSavingSalesforce}
                onClick={onSaveSalesforce}
            >
                Save Changes
            </button>
            {Boolean(isSavingSalesforce) && (
                <div className="circular-progress-loader">
                    <CircularProgress className="circular-progress-spinner" size={70} variant="indeterminate" />
                </div>
            )}
        </div>
    )
}

export default ManageSalesforceType
